import { testimonialsData } from '@/mocks/home';

export default function Testimonials() {
  return (
    <section className="w-full py-16 md:py-20 px-4 md:px-6 bg-background-50" aria-labelledby="testimonials-heading">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <h2 id="testimonials-heading" className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-4">
            被 10 万+ 职场人信赖
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            听听他们怎么说——真实的用户反馈，见证好联系带来的改变
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {testimonialsData.map((item) => (
            <div
              key={item.id}
              className="bg-background-50 border border-background-200/70 rounded-lg p-6 flex flex-col"
            >
              <div className="flex items-center gap-1 mb-4">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i
                    key={i}
                    className={`text-sm ${i < item.rating ? 'text-primary-500 ri-star-fill' : 'text-background-300 ri-star-fill'}`}
                  ></i>
                ))}
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed mb-5 flex-1">
                &ldquo;{item.content}&rdquo;
              </p>
              <div className="flex items-center gap-3 pt-4 border-t border-background-200/70">
                <div className="w-10 h-10 rounded-full overflow-hidden bg-background-200 flex-shrink-0">
                  <img
                    src={item.avatar}
                    alt={item.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground-900">{item.name}</div>
                  <div className="text-xs text-foreground-500">{item.role}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}